<template>
  <div class="app-container" style="padding:0;">
    <list row-key="UserId" ref="list" unit="合并工单" :page="page" show-query :query-params="params" :get-data-func="api.getDocList" @reset="$refs.picker.clear()"
    show-checkbox @check-change="onCheckChange2"> <!-- @row-select="rowSelect" -->
      <template slot="query">
        <el-form-item el-form-item label="单据日期">
          <range-picker style="width:180px !important;" ref="picker" @change="(x) => {params.DocDateStart=x.Start;params.DocDateEnd=x.End}" />
        </el-form-item>
        <el-form-item label="存货名称">
          <el-input style="width:180px;" clearable v-model="params.ProductName" placeholder="请输入存货名称" />
        </el-form-item>
        <el-form-item label="加工阶段">
          <el-select clearable v-model="params.Stage" :disabled="disabled" style="width:180px;">
            <el-option v-for="item in machiningStageList" :key="item.MachiningStageId" :value="item.MachiningStageId" :label="item.Name"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="模具名称">
          <el-input style="width:180px;" clearable v-model="params.MouldName" placeholder="请输入模具名称" />
        </el-form-item>
        <el-form-item label="工单号">
          <el-input style="width:180px;" clearable v-model="params.WorkDocNo" placeholder="请输入工单号" />
        </el-form-item>
        <el-form-item label="订单号">
          <el-input style="width:180px;" clearable v-model="params.OrderNo" placeholder="请输入订单号" />
        </el-form-item>
        <el-form-item label="部门" v-if="params.ProductionType===0">
          <el-input style="width:180px;" clearable v-model="params.DpName" placeholder="请输入部门" />
        </el-form-item>
        <el-form-item label="加工商" v-if="params.ProductionType===1">
          <el-input style="width:180px;" :disabled="TradeUnitDisabled" clearable v-model="params.TradeUnitName" placeholder="请输入加工商" />
        </el-form-item>        
        <el-form-item label="生产批号">
          <el-input style="width:180px;" clearable v-model="params.BatchNumber" placeholder="请输入生产批号" />
        </el-form-item>   
        <el-form-item label="存货条码">
          <el-input style="width:180px;" clearable v-model="params.BarCode" placeholder="请输入存货条码" />
        </el-form-item>
      </template>
      <template slot="table">
        <el-table-column prop="WorkDocNo" label="工单号" min-width="130" align="left"></el-table-column>
        <el-table-column prop="BatchNumber" label="生产批号" min-width="130" align="left"></el-table-column>
        <el-table-column prop="BarCode" label="存货条码" min-width="130" align="left"></el-table-column>
        <el-table-column prop="ProductName" label="存货名称" min-width="120" align="left"></el-table-column>        
        <el-table-column prop="ColorName" label="颜色" min-width="120" align="left">
        </el-table-column>
        <el-table-column prop="PropertyName" label="附加属性" min-width="120" align="left">
        </el-table-column>
        <el-table-column prop="Quantity" :label="params.Stage==1?'生产模数':'生产数量'" min-width="120" align="right">
          <template slot-scope="{ row }">
            <span>{{ $commonJs.toThousands(row.Quantity) }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="Stage" label="加工阶段" min-width="120" align="left">
          <template slot-scope="{ row }">
            <span v-for="(item,index) in machiningStageList" :key="index" v-show="row.Stage === item.MachiningStageId">{{item.Name}}</span>
          </template>
        </el-table-column>
        <el-table-column v-if="params.ProductionType===0" prop="DpName" label="部门" min-width="120" align="left"></el-table-column>
        <el-table-column v-if="params.ProductionType===1" prop="TradeUnitName" label="加工商" min-width="120" align="left"></el-table-column>
         <el-table-column prop="DocDate" label="单据日期" :formatter="dateFormat" min-width="120" align="left"></el-table-column>
       <!-- <el-table-column prop="ProgrammeName" label="工艺方案" min-width="120" align="left"></el-table-column> -->
      </template>
    </list>
    <div style="margin-top:-45px">
      <el-button type="primary" @click="getDetails">查询</el-button>
    </div>
    <el-table border class="table_bottom table-line tb-c-head" :data="tableData" style="margin-top: 18px;" @selection-change="onCheckChange">
      <el-table-column type="selection" align="center" fixed :width="50" />
      <el-table-column prop="ProductNo" label="存货编码" min-width="100" align="center"></el-table-column>
      <el-table-column prop="ProductName" label="存货名称" min-width="100" align="center"></el-table-column>
      <el-table-column prop="BarCode" label="存货条码" min-width="100" align="center"></el-table-column>
      <el-table-column prop="ProductSpec" label="规格型号" min-width="100" align="center"></el-table-column>
      <el-table-column prop="PropertyName" label="附加属性" min-width="100" align="center">
        <template slot-scope="{ row }">
          <span>{{row.PropertyName}}</span>
        </template>
      </el-table-column>
      <el-table-column prop="ColorName" label="颜色" min-width="100" align="center">
        <template slot-scope="{ row }">
          <span>{{row.ColorName}}</span>
        </template>
      </el-table-column>
      <el-table-column prop="Quantity" label="数量" min-width="100" align="center"></el-table-column>
    </el-table>
  </div>
</template>
<script>
import listMixin from "@/mixins/list";
import list from "@/components/common/list";
import moment from "moment"
import { forEach } from "lodash";

// import iForm from '@/data/sys/user/IForm.json'

export default {
  mixins: [listMixin],
  components: {
    list,
  },
  props: {
    tempParams: {
      typeof: Object,
      default: () => { },
    },
    type: {
      type: Boolean,
      default: true,
    },
    docType: {
      type: Number,
      default: 1
    },
    tableType: {
      type: Number,
      default: 0,
    },
    consumablesType: {
      type: Number,
      default: 0,
    },
    DictionaryId: {
      type: Number,
      default: 0,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    TradeUnitDisabled: {
      type: Boolean,
      default: false,
    },
  },
  watch: {
    tempParams(val) {
      console.log('val11111', val)
      this.params.status = val.status
      this.params.Statuses = val.Statuses
      this.params.ProductionType = val.ProductionType
      this.params.Stage = val.Stage
      this.params.OrderType = val.OrderType ?? 0
      this.params.TradeUnitName = val.TradeUnitName
    },
  },
  data() {
    return {
      params: {
        DocDateStart: "",
        DocDateEnd: "",
        ProductName: "",
        Stage: "",
        MouldName: "",
        WorkDocNo: "",
        OrderNo: "",
        TradeUnitName: "",
      },
      data: {},
      commonApi: require("@/api/common/common").default,
      api: require('@/api/production/workDoc').default,
      machiningStageApi: require("@/api/ba/machiningStage").default,
      selectList: [],
      arr: [],
      routesName: '',
      list: [],
      subList: [],
      tableData: [],
      extraList: [],
      TradeUnitId: null,
      machiningStageList: [],
      TradeUnitDisabled: false
    };
  },
  created() {
    this.getParams()
    this.machiningStageApi.list({ Status: 1 }).then((res) => {
      this.machiningStageList = res.Data;
      if(this.machiningStageList == null)
        return;
      const item = this.machiningStageList.find(item => item.Name === '注塑');
      if (item) {
        this.$set(item, 'MachiningStageId', 0);
      }
    });
  },
  mounted() {
    this.onClear();
    this.getData();
  },
  methods: {
    dateFormat: function (row, column) {
      var date = row[column.property];
      if (date == undefined || date == '') {
        return ''
      }
      return moment(date).format("YYYY-MM-DD")
    },
    getParams() {
      console.log('this.tempParams', this.tempParams)
      this.params.status = this.tempParams.status
      this.params.Statuses = this.tempParams.Statuses
      this.params.ProductionType = this.tempParams.ProductionType
      this.params.OrderType = this.tempParams.OrderType
      this.params.TradeUnitName = this.tempParams.TradeUnitName

      if (this.tableType === 1) {
        this.params.Stage = this.tempParams.Stage
      }
      // if(this.DictionaryId>0){
      //   this.params.ProcessStage=this.DictionaryId
      // }
    },
    del() { },
    checkChange(list) {
      this.list = list;
    },
    clear() {
      this.list = [];
      this.subList = [];
    },
    onCheckChange(list) {
      console.log("🚀 ~ onCheckChange ~ list:", list)
      this.subList = list;
    },
    rowSelect({ WorkDocId, Stage, WorkDocType }) {
      // var loading = this.$loading({
      //     lock: true,
      //     text: "正在查询...",
      //     spinner: "el-icon-loading",
      //     customClass: "my_loading",
      //     background: "rgba(0, 0, 0, 0.3)",
      //   });
      this.api.info(WorkDocId).then(res => {
        this.extraList = []


        // loading.close();
        if (res.Code === 0) {
          if (this.tableType === 0) {
            this.TradeUnitId = res.Data.ProductionDpId ?? null;

            res.Data.MaterialModels.forEach(item => {
              item.ProductionType = WorkDocType
              item.UnitId = item.QuantityUnit;
              item.Quantity = item.Quantity - (item.PrUseDocOccupyQuantity ?? 0);
            })

            let tList = res.Data.MaterialModels.filter(item => item.Quantity > 0)
            this.tableData = tList;
            //  if(Stage === 1 ){
            //   res.Data.ProductModels.forEach(item => {
            //     item.ProductionType = WorkDocType
            //     item.UnitId  = item.Unit;
            //   })
            //   this.tableData = res.Data.ProductModels;
            //   console.log('this.tableData', this.tableData)
            // }else{
            //   res.Data.MaterialModels.forEach(item => {
            //     item.ProductionType = WorkDocType
            //     item.UnitId  = item.QuantityUnit;
            //   })
            //   this.tableData = res.Data.MaterialModels;
            // }
          } else {
            this.TradeUnitId = res.Data.ProductionDpId ?? null;

            if (Stage === 0) {
              res.Data.MaterialModels.forEach(item => {
                item.ProductionType = WorkDocType
              })
              // this.tableData = res.Data.MaterialModels;

              let quantity = res.Data.ProductModels[0].Quantity == 0 ? 1 : res.Data.ProductModels[0].Quantity;
              let sourceNo = res.Data.WorkDocNo;
              let sourceId = res.Data.WorkDocId;
              let sourceDtsId = res.Data.ProductModels[0].WorkDocProductId
              res.Data.ProductModels[0].BomRubbers.forEach((item) => {
                item.type = 1;
                item.InitQuantity = item.Quantity;
                if (this.docType === 1) {
                  item.Quantity = item.NeedQuanity - item.InQuantity;
                } else {
                  item.Quantity = item.NeedQuanity - item.DirectInQuantity;
                }

                item.WorkShopId = res.Data.DpId;
                item.WorkShopName = res.Data.DpName;
                item.WorkDocNo = sourceNo
                item.ProcessStage = 0
                item.UnitId = item.PdUnitId;
                item.UnitName = item.PdUnitName;
                item._WorkDocProductId = sourceDtsId;
                item._WorkDocId = sourceId;
              });

              let tList = res.Data.ProductModels[0].BomRubbers.filter(item => item.Quantity > 0)
              this.tableData = tList

              console.log("this.tableData", this.tableData);
              this.extraList = res.Data.ProductModels;
            } else {
              res.Data.ProductModels.forEach(item => {
                item.WorkShopId = res.Data.DpId
                item.WorkShopName = res.Data.DpName
                item.ProductionType = WorkDocType
                item.UnitId = item.Unit;
                if (this.docType === 1) {
                  item.Quantity = item.Quantity - (item.StInDocOccupyQuantity ?? 0);
                } else {
                  item.Quantity = item.Quantity - (item.StDirectInDocOccupyQuantity ?? 0);
                }

              })
              this.tableData = res.Data.ProductModels;
            }
          }
        } else {
          this.$message({ type: 'warning', message: res.Msg })
        }
      }).catch(err => {
        console.log(err)
      })

    },
    getDetails() {
      console.log("getDetails", JSON.parse(JSON.stringify(this.selectList)));
      var ids = this.selectList.map(x => x.WorkDocId);
      if(ids.length==0){
        return this.$message.warning("未选中任何数据");
      }
      this.api.infoList({ ids }).then(res => {
        this.extraList = []
        console.log(res.Data,"infolist")
        if (res.Code === 0) {
          this.tableData = [];
          res.Data.forEach(x => {
            var doc = this.selectList.find(item => item.WorkDocId === x.WorkDocId)
            if (this.tableType === 0) {
              this.TradeUnitId = x.ProductionDpId ?? null;
  
              x.MaterialModels.forEach(item => {
                item.ProductionType = doc?.WorkDocType
                item.UnitId = item.QuantityUnit;
                if(this.consumablesType == 0){
                  item.Quantity = item.Quantity - (item.PrGetDocOccupyQuantity ?? 0);
                } else {
                  item.Quantity = item.Quantity - (item.PrUseDocOccupyQuantity ?? 0);
                }
              })
  
              let tList = x.MaterialModels.filter(item => item.Quantity > 0)
              this.tableData = [...this.tableData, ...tList]
            }else{
              this.TradeUnitId = x.ProductionDpId ?? null;
              if (doc?.Stage === 0) {
                x.MaterialModels.forEach(item => {
                  item.ProductionType = doc?.WorkDocType
                })
                // this.tableData = x.MaterialModels;
  
                let quantity = x.ProductModels[0].Quantity == 0 ? 1 : x.ProductModels[0].Quantity;
                let sourceNo = x.WorkDocNo;
                let sourceId = x.WorkDocId;
                let sourceDtsId = x.ProductModels[0].WorkDocProductId
                x.ProductModels[0].BomRubbers.forEach((item) => {
                  item.type = 1;
                  item.InitQuantity = item.Quantity;
                  if (this.docType === 1) {
                    item.Quantity = item.NeedQuanity - item.InQuantity;
                  } else {
                    item.Quantity = item.NeedQuanity - item.DirectInQuantity;
                  }
  
                  item.WorkShopId = x.DpId;
                  item.WorkShopName = x.DpName;
                  item.WorkDocNo = sourceNo
                  item.ProcessStage = 0
                  item.UnitId = item.PdUnitId;
                  item.UnitName = item.PdUnitName;
                  item._WorkDocProductId = sourceDtsId;
                  item._WorkDocId = sourceId;
                  item._MouldQuantity = x.ProductModels[0].Quantity - x.ProductModels[0].TotalInQuantity
                });
  
                let tList = x.ProductModels[0].BomRubbers.filter(item => item.Quantity > 0)
                this.tableData = [...this.tableData, ...tList]
  
                this.extraList = [...this.extraList, ...x.ProductModels]
              } else {
                x.ProductModels.forEach(item => {
                  item.WorkShopId = x.DpId
                  item.WorkShopName = x.DpName
                  item.ProductionType = doc?.WorkDocType
                  item.UnitId = item.Unit;
                  if (this.docType === 1) {
                    item.Quantity = item.Quantity - (item.StInDocOccupyQuantity ?? 0);
                  } else {
                    item.Quantity = item.Quantity - (item.StDirectInDocOccupyQuantity ?? 0);
                  }
  
                })
                this.tableData = [...this.tableData, ...x.ProductModels]
              }
            }
          })
          console.log("this.tableData", this.tableData);
        } else {
          this.$message({ type: 'warning', message: res.Msg })
        }
      })
    },
    onCheckChange2(data) {
      this.selectList = data;
    },
    onClear() {
      console.log(22222)
      this.selectList = [];
      this.tableData = [];
    }
  },
};
</script>
